<template>
  <Navbar :center-text="$t('ManageSystemView.manageSystem')"
          :message="this.message"
          :message-type="this.messageType">
  </Navbar>
  <div class="container mt-4">
    <div class="row justify-content-start">
      <ul class="nav flex-column col-md-2 col-sm-2 border-right"
          style="border-right:1px solid #dee2e6;"
          id="myTab">
        <li class="nav-item">
          <button class="nav-link active align-content-start"
                  id="odk-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#odk"
                  type="button"
                  role="tab"
                  aria-controls="odk"
                  aria-selected="true">
            {{ $t('ManageSystemView.odkSettings') }}
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link align-content-start"
                  id="email-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#email"
                  type="button"
                  role="tab"
                  aria-controls="email"
                  aria-selected="false">
            {{ $t('ManageSystemView.emailSettings') }}
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link align-content-start"
                  id="termsAndConditions-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#termsAndConditions"
                  type="button"
                  role="tab"
                  aria-controls="termsAndConditions"
                  aria-selected="false">
            {{ $t('ManageSystemView.termsAndConditionsSettings') }}
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link align-content-start"
                  style="text-align:left;"
                  id="indicators-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#indicators"
                  type="button"
                  role="tab"
                  aria-controls="indicators"
                  aria-selected="false">
            {{ $t('ManageSystemView.diagnosticIndicatorSettings') }}
          </button>
        </li>
      </ul>

      <div class="tab-content col-md-10 col-sm-10"
           id="myTabContent">
        <div class="tab-pane fade show active"
             id="odk"
             role="tabpanel"
             aria-labelledby="platform-tab">
          <ODKSettings></ODKSettings>
        </div>
        <div class="tab-pane fade"
             id="email"
             role="tabpanel"
             aria-labelledby="email-tab">
          <EmailSettings></EmailSettings>
        </div>
        <div class="tab-pane fade"
             id="termsAndConditions"
             role="tabpanel" aria-labelledby="termsAndConditions-tab">
          <TermsSettings></TermsSettings>
        </div>
        <div class="tab-pane fade"
             id="indicators"
             role="tabpanel"
             aria-labelledby="contact-tab">
          <IndicatorSettings></IndicatorSettings>
        </div>
      </div>
    </div>
  </div>
  <Footerbar></Footerbar>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footerbar from "@/components/Footerbar.vue";
import PlatformSettings from "@/views/settings/PlatformSettings.vue";
import EmailSettings from "@/views/settings/EmailSettings.vue";
import IndicatorSettings from "@/views/settings/IndicatorSettings.vue";
import ODKSettings from "@/views/settings/ODKSettings.vue";
import TermsSettings from "@/views/settings/TermsSettings.vue";

export default {
  data() {
    return {
      message: null,
      messageType: null,
    }
  },
  components: {
    TermsSettings,
    ODKSettings,
    IndicatorSettings,
    EmailSettings,
    PlatformSettings,
    Navbar,
    Footerbar,
  }
};

</script>
